import React from 'react'
import styled from '@emotion/styled'
import { Badge } from './Badge'
import { Box } from '@chakra-ui/react'

const MobileContainer = styled(Box)`
  @media (max-width: 32em) {
    & > div > div {
      transform: rotate(90deg) scale(0.6);
      margin: 100px 0;
    }
  }
`

export const VisitorBadge = (props: React.ComponentProps<typeof Badge>) => {
  return (
    <MobileContainer>
      <Badge {...props} />
    </MobileContainer>
  )
}
